<lib-filters-component [filters_options]="lang_service.filtersType"></lib-filters-component>
